import React, { useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PanelMenu } from "primereact/panelmenu";
import { AppContext } from "../../context/index";
import { pointsFeatures } from "../../constants";
import { CustomDialog, DialogProps } from "../dialog/CustomDialog";


interface SidebarProps {
  items: any;
  visible: boolean;
  setEnableSidepanel: React.Dispatch<React.SetStateAction<boolean>>;
  isBigScreen: boolean;
  handleModalProps: Function;
}

export const SidePanel: React.FC<SidebarProps> = ({
  items,
  visible,
  setEnableSidepanel,
  isBigScreen,
  handleModalProps
}) => {
  const currentPath = useLocation().pathname;
  const navigate = useNavigate();
  const { t, setAppState, appState: {
    selectedApp, showChangeClientButton, tenantAuth,
    showChangeAppButton, tenantId, selectedTenantId, isParentTenant
  } } = useContext(AppContext);
  const [modalProps, setModalProps] = useState<DialogProps>({
    visible: false,
  } as DialogProps);

  const menuItems = items
    .filter((mainItemm: any) => !mainItemm.isHidden)
    .map((mainItem: any) => ({
      ...mainItem,
      label: t(`Menu.${mainItem.label}`),
      // expanded: mainItem.label && isBigScreen,
      expanded: currentPath !== '/' && mainItem?.items?.filter(
        (item: any) => item?.target !== '/' && (currentPath.includes(item?.target) || item?.items?.filter(
          (subItem:any) => subItem?.target !== '/' && currentPath.includes(subItem?.target))?.length > 0))?.length > 0,
      command: !!mainItem?.target
      ? () => {
            (mainItem?.targettype === "INTERNAL")
            ? navigate(`${mainItem?.target}`)
            : window.location.href = mainItem?.target;
            sessionStorage.removeItem('filters-table');
            setEnableSidepanel(false);
        }
      : () => handleModalProps(
            mainItem?.actionType,
            mainItem?.label.toLowerCase().includes('client')
          ),
      items: ((mainItem?.label !== 'accessMenuLabel' && mainItem?.items?.length > 0 &&
        !mainItem.isHidden) || mainItem?.label === 'accessMenuLabel') ?
        (() =>
          {
            let newItemsInside = [...mainItem.items];
            if (mainItem?.label === 'accessMenuLabel' && !mainItem?.items?.find((item:any)=>item?.functionalityId === 'COD_AREPM')) {
              newItemsInside = [ ...newItemsInside, {
                label: "auditReportManagementMenuLabel",
                icon: null,
                target: "/auditreport",
                targettype: "INTERNAL",
                order: 99,
                items: [],
            }];
            };
          return newItemsInside.map((subItem: any) => ({
          ...subItem,
          label: t(`Menu.${subItem.label}`),
          expanded: currentPath !== '/' && subItem?.target !== '/' && subItem?.items?.filter((item: any) => currentPath.includes(item?.target)).length > 0,
          style: {
            backgroundColor: `${
              subItem?.target !== '/' && subItem?.target !== '' && currentPath.includes(subItem?.target)
                ? 'var(--mainColorShade30)' : undefined}`,
          },
          [subItem?.target && "command"]: () => {
            if (subItem?.targettype === "INTERNAL") {
              const segmentTarget = subItem?.target?.split('/');
              const tidx = pointsFeatures.indexOf(segmentTarget[2]);
              if (tidx !== -1) {
                setAppState((prev) => ({
                  ...prev,
                  activeIndexPoints: tidx,
                }));
                navigate(`/${segmentTarget[1]}`);
                const event = new CustomEvent<number>("POINTS::SET::TABVIEW", { detail: tidx })
                window.dispatchEvent(event)
                sessionStorage.removeItem('filters-table');
              } else {
                navigate(`${subItem?.target}`);
                sessionStorage.removeItem('filters-table');
              };
              setEnableSidepanel(false);
            } else {
              window.location.href = subItem?.target;
              sessionStorage.removeItem('filters-table');
            };
          },
          items:
            (subItem?.items?.length > 0 &&
            !subItem.isHidden)
            ?  subItem.items.map((link: any) => ({
                ...link,
                label: t(`Menu.${link.label}`),
                command: () => {
                  if (!!link?.target) {
                    sessionStorage.removeItem('filters-table');
                    const segmentTarget = link.target.split('/')
                    const tidx = pointsFeatures.indexOf(segmentTarget[2])
                    if (tidx !== -1) {
                      setAppState((prev) => ({
                        ...prev,
                        activeIndexPoints: tidx,
                      }));
                      navigate(`/${segmentTarget[1]}`);
                      const event = new CustomEvent<number>("POINTS::SET::TABVIEW", { detail: tidx })
                      window.dispatchEvent(event)
                      sessionStorage.removeItem('filters-table');
                    }
                    else {
                      navigate(`${link.target}`);
                      sessionStorage.removeItem('filters-table');
                    }
                    setEnableSidepanel(false);
                  }
                },
                items:
                  (link?.items?.length > 0) &&
                  !link.isHidden ?
                  link.items.map((item: any) => ({
                    ...item,
                    label: t(`Menu.${item.label}`),
                    command: () => {
                      navigate(`${item.target}`);
                      sessionStorage.removeItem('filters-table');
                      setEnableSidepanel(false);
                    },
                  }))
                  : undefined,
              }))
            : undefined,
        }))})() : undefined,
    }));
  
  return (
    <>
      <div
        className={`p-mask-sidebar ${(visible && !isBigScreen) ? "active" : ""}`}
        onClick={() => setEnableSidepanel(false)}
      ></div>
      <div className={`p-sidebar ${isBigScreen ? '' : 'transition '}${visible ? "active" : ""}`}>
        <div className="p-sidebar-header">
          {
            !isBigScreen &&
            <button className="sb-header-btn">
              <div className="sidepanel__close-icon-container" onClick={() => setEnableSidepanel(false)} >
                <i className="iu iu-icon-close sb-header-icon" />
              </div>
            </button>
          }
        </div>
        <div className={`p-sidebar-content ${((tenantId !== tenantAuth) || (selectedTenantId && isParentTenant) || (!selectedTenantId && !isParentTenant) || (selectedTenantId && selectedApp))
          ? ((showChangeAppButton && showChangeClientButton)
            ? (!!selectedApp ? 'three-childs' : 'two-childs')
            : ((showChangeAppButton || showChangeClientButton)
              ? 'two-childs'
              : 'one-child'))
          : 'one-child'}`}
        >
          <PanelMenu model={menuItems} />
        </div>
      </div>
      <CustomDialog
        title={modalProps.title}
        visible={modalProps.visible}
        content={modalProps.content}
        handleModalState={setModalProps}
        onConfirm={modalProps.onConfirm}
        closable={modalProps.closable}
        acceptLabel={modalProps.acceptLabel}
        rejectLabel={modalProps.rejectLabel}
        onReject={modalProps.onReject}
      />
    </>
  );
};
